import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import AlmacenGestion from './view/AlmacenGestion'

// const AlmacenRegistroApp = lazy(() => import('./view/AlmacenRegistro'))

export const almacenRoutesMap = {
  gestion: {
    path: '/almacen/gestion',
    name: 'Almacenes',
    action: 'ALMACENES',
  },
  registro: {
    path: '/almacen/nuevo',
    name: 'Nuevo Almacen',
    action: 'ADMINISTRAR_ALMACEN',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const almacenRoutes = [
  {
    path: almacenRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <AlmacenGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  /*{
    path: almacenRoutesMap.upsert.path,
    element: <AlmacenRegistroApp />,
    auth: authRoles.admin,
  },*/
]

export default almacenRoutes
